import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type AdviserClientsResumeKycClickedProps = EventProps

/**
 * @event adviser_clients_resume_kyc_clicked
 * @description Emitted when the "Resume" button is clicked for a client with KYC in progress.
 */
export const AdviserClientsResumeKycClickedAnalytics = createAnalyticsStatic<AdviserClientsResumeKycClickedProps>(
    ANALYTICS_EVENTS.ADVISER_CLIENTS_RESUME_KYC_CLICKED,
)

export default AdviserClientsResumeKycClickedAnalytics
